define.alias("shared/utils/object-methods/object-camel-to-snake", "media/utils/object-methods/object-camel-to-snake");